module.exports = __webpack_public_path__ + "static/media/login-form.17fa3f20.png";